import React from 'react';

export default function PreviewContent({ url, mime }) {
    if (mime.startsWith('image/')) {
        return (
            <div className="flex items-center justify-center h-full">
                <img src={url} alt="Preview" className="max-h-full max-w-full rounded" />
            </div>
        );
    }
    if (mime === 'application/pdf') {
        return (
            <iframe src={url} title="PDF Preview" className="w-full h-full rounded bg-white" />
        );
    }
    if (mime.startsWith('video/')) {
        return (
            <video src={url} controls className="w-full rounded" style={{ maxHeight: '65vh' }} />
        );
    }
    if (mime.startsWith('audio/')) {
        return (
            <div className="flex flex-col items-center justify-center gap-3">
                <audio src={url} controls />
                <span className="text-sm text-slate-500">Audio preview</span>
            </div>
        );
    }
    return (
        <div className="text-center text-sm text-slate-600">
            Preview not available for this file type. Please download to view the contents.
        </div>
    );
}
